export interface Address {
  street: string;
  city: string;
  state: string;
  postalCode: string;
}

const clean = (value: string | null | undefined): string => (value ?? '').trim();

export const formatAddress = (address: Address | null | undefined, fallback = ''): string => {
  if (!address) {
    return fallback;
  }

  const regionParts = [clean(address.state).toUpperCase(), clean(address.postalCode)];
  const region = regionParts.filter((part) => part !== '').join(' ');

  const parts = [clean(address.street), clean(address.city), region].filter((part) => part !== '');

  return parts.length === 0 ? fallback : parts.join(', ');
};
